import GameCode from '../games/GameCode';
import Sc2Character from './Sc2Character';

class CharacterFactory {
    static createInstance(userId, gameCode, identificationName, specificProperties, createdAt, updatedAt) {
        switch (gameCode) {
            case GameCode.starcraft2:
                const profileUrl = specificProperties.profileUrl;

                return Sc2Character.createInstance(userId, identificationName, profileUrl, createdAt, updatedAt);
            default:
                throw new Error('Create character failed.');
        }
    }
}

export default CharacterFactory;
